import { Assets, type Texture, type TextureSource } from 'pixi.js';
import hueRampUrl from '../../assets/baked/hues/hues.webp?url';

/**
 * The baked hue table: a `32 x count` RGBA ramp (one hue gradient per row),
 * decoded offline from `hues.mul` by the converter. The hue shader samples it by
 * row (which hue) and column (source-pixel brightness, 0..31). See
 * {@link ./hueFilter}.
 */
export interface HueTable {
  /** The ramp texture source, bound straight into the hue filter. */
  source: TextureSource;
  /** Number of hue rows (= texture height); needed to turn a hue id into a row. */
  count: number;
}

/**
 * Load the baked hue ramp. Sampled with `nearest` so each of the 32 gradient
 * steps stays a crisp UO colour rather than blending into its neighbours.
 */
export async function loadHueTable(): Promise<HueTable> {
  const texture = await Assets.load<Texture>(hueRampUrl);
  texture.source.scaleMode = 'nearest';
  return { source: texture.source, count: texture.source.height };
}
